import { Modal, Form, Input, Select, message } from "antd";
import { ExpenseCategory } from "@/types/expenseCategory";
import { useUpdateExpenseCategory } from "@/pages/Expenses/ManageExpense/hooks/useExpenseCategories";
import { useGetExpenseTypesOptions } from "@/pages/Expenses/ManageExpense/hooks/useExpenseTypes";
import { useEffect } from "react";
import { SelectOption } from "@/types/select";
import { UpdateExpenseCategoryFormValues } from "@/pages/Expenses/ManageExpense/api/expenseCategories";

interface EditModalProps {
  data?: ExpenseCategory;
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const EditModal = ({ data, isOpen, onClose, onSuccess }: EditModalProps) => {
  const [form] = Form.useForm();
  const { mutate: updateExpenseCategory, isPending } =
    useUpdateExpenseCategory();
  const { data: expenseTypes } = useGetExpenseTypesOptions();

  const handleSubmit = async (values: UpdateExpenseCategoryFormValues) => {
    const payload: UpdateExpenseCategoryFormValues = {
      ...values,
      id: data?.id || "",
    };

    updateExpenseCategory(payload, {
      onSuccess: () => {
        message.success("Successfully updated expense category");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  useEffect(() => {
    if (!data) {
      return;
    }

    form.setFieldsValue({
      name: data.name,
      expense_type_id: data.expense_type?.id,
    });
  }, [data, form]);

  const expenseTypeOptions: SelectOption[] = (expenseTypes || [])
    .filter((type) => type.is_active)
    .map((type) => ({
      label: type.name,
      value: type.id,
    }));

  return (
    <Modal
      title="Edit Category"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Update"
      destroyOnHidden
    >
      <Form<UpdateExpenseCategoryFormValues>
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={
          data && {
            name: data.name,
            expense_type_id: data.expense_type?.id,
          }
        }
      >
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="expense_type_id"
          label="Expense Type"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Select expense type"
            options={expenseTypeOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditModal;
